import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import withI18next from '~/../hocs/_withI18next';
import Config from '~/config';
import { makeSelectIsAuthenticated } from '~/containers/AuthProvider/selectors';

@withI18next()
class FAQComponent extends React.Component {
  render() {
    const { t, lng } = this.props;
    return (
      // <div className={`faq bg-op2-${Config.serviceType}`}>
      <div className={'faq '}>
        <div className="container pt50 pb50">
          <h1
            className={`text-center ${Config.getPrefixContent(
              'color-ac-primary',
            )} pb10`}
          >
            <b>{t('credit_premium_FAQ_title')}</b>
          </h1>

          <div className="chat-wrapper">
            <div className="chat-message padding">
              {/* Question 1 */}
              <div
                className={`chat-message chat-message-sender chat-message-sender-${Config.serviceType}`}
              >
                <img
                  className="chat-image chat-image-default"
                  src={`${Config.staticPrefix}/static/assets/image/premium/credit-card/user.png`}
                  alt={'logo credit card'}
                />

                <div className="chat-message-wrapper">
                  <div className="chat-message-content">
                    <p>{t('credit_premium_FAQ_content11')}</p>
                  </div>
                </div>
              </div>
              <div className="chat-message chat-message-recipient">
                <img
                  className="chat-image chat-image-default"
                  src={`${Config.staticPrefix}/static/assets/image/premium/credit-card/cs.png`}
                  alt={'logo credit card'}
                />
                <div className="chat-message-wrapper">
                  <div className="chat-message-content">
                    <p>{t('credit_premium_FAQ_content12')}</p>
                  </div>
                </div>
              </div>

              {/* Question 2 */}
              <div
                className={`chat-message chat-message-sender chat-message-sender-${Config.serviceType}`}
              >
                <img
                  className="chat-image chat-image-default"
                  src={`${Config.staticPrefix}/static/assets/image/premium/credit-card/user.png`}
                  alt={'logo credit card'}
                />

                <div className="chat-message-wrapper">
                  <div className="chat-message-content">
                    <p>{t('credit_premium_FAQ_content3')}</p>
                  </div>
                </div>
              </div>
              <div className="chat-message chat-message-recipient">
                <img
                  className="chat-image chat-image-default"
                  src={`${Config.staticPrefix}/static/assets/image/premium/credit-card/cs.png`}
                  alt={'logo credit card'}
                />
                <div className="chat-message-wrapper">
                  <div className="chat-message-content">
                    <p>{t('credit_premium_FAQ_content4')}</p>
                  </div>
                </div>
              </div>

              {/* Question 3 */}
              <div
                className={`chat-message chat-message-sender chat-message-sender-${Config.serviceType}`}
              >
                <img
                  className="chat-image chat-image-default"
                  src={`${Config.staticPrefix}/static/assets/image/premium/credit-card/user.png`}
                  alt={'logo credit card'}
                />

                <div className="chat-message-wrapper">
                  <div className="chat-message-content">
                    <p>{t('credit_premium_FAQ_content13')}</p>
                  </div>
                </div>
              </div>
              <div className="chat-message chat-message-recipient">
                <img
                  className="chat-image chat-image-default"
                  src={`${Config.staticPrefix}/static/assets/image/premium/credit-card/cs.png`}
                  alt={'logo credit card'}
                />
                <div className="chat-message-wrapper">
                  <div className="chat-message-content">
                    <p>{t('credit_premium_FAQ_content14')}</p>
                  </div>
                </div>
              </div>

              {/* Question 4 */}
              <div
                className={`chat-message chat-message-sender chat-message-sender-${Config.serviceType}`}
              >
                <img
                  className="chat-image chat-image-default"
                  src={`${Config.staticPrefix}/static/assets/image/premium/credit-card/user.png`}
                  alt={'logo credit card'}
                />

                <div className="chat-message-wrapper">
                  <div className="chat-message-content">
                    <p>{t('credit_premium_FAQ_content9')}</p>
                  </div>
                </div>
              </div>
              <div className="chat-message chat-message-recipient">
                <img
                  className="chat-image chat-image-default"
                  src={`${Config.staticPrefix}/static/assets/image/premium/credit-card/cs.png`}
                  alt={'logo credit card'}
                />
                <div className="chat-message-wrapper">
                  <div className="chat-message-content">
                    <p>{t('credit_premium_FAQ_content10')}</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <a
            className={`btn btn-ac-primary btn-${Config.serviceType} btn-support`}
            href={`${Config.getSiteURL()}/inquiry`}
          >
            {t('support')}
          </a>
        </div>
        <style jsx global>
          {`
            .faq .container {
              display: flex;
              flex-direction: column;
              align-items: center;
            }

            .faq .btn-support {
              margin: 0 auto;
              margin-top: 28px;
              width: 150px;
            }

            .chat-wrapper {
              width: 100%;
              display: table;
              overflow: hidden;
              padding: 15px 100px;
            }

            .chat-wrapper:before {
              content: ' ';
              display: block;
            }

            .chat-wrapper .chat-content {
              background-color: #3e3e3f;
            }

            .chat-wrapper .chat-image {
              float: left;
              border-radius: 50%;
            }

            .chat-wrapper .chat-image.chat-image-default {
              width: 60px;
              height: 60px;
            }

            .chat-wrapper .chat-message {
              margin-bottom: 20px;
              width: 100%;
              display: table;
              overflow: hidden;
            }

            .chat-wrapper .chat-message:before {
              content: ' ';
              display: block;
            }

            .chat-wrapper .chat-message:last-of-type {
              margin-bottom: 0;
            }

            .chat-wrapper .chat-message .chat-message-wrapper {
              max-width: 70%;
              display: table;
              margin: 0 20px;
              padding-top: 10px;
              position: relative;
            }

            .chat-wrapper .chat-message .chat-message-wrapper:before {
              content: ' ';
              display: block;
              width: 0;
              height: 0;
              border: 12px solid transparent;
              top: 20px;
              position: absolute;
              z-index: 2;
            }

            .chat-wrapper .chat-message .chat-message-wrapper p {
              padding: 10px 20px;
              color: #fff;
              background: #3e3e3f;
              border-radius: 2px;
            }

            .chat-wrapper .chat-message .chat-message-wrapper p:first-of-type {
              border-top: 0 !important;
            }

            .chat-wrapper
              .chat-message.chat-message-recipient
              .chat-message-wrapper,
            .chat-wrapper
              .chat-message.chat-message-recipient
              .chat-message-content {
              float: left;
            }

            .chat-wrapper
              .chat-message.chat-message-recipient
              .chat-message-wrapper:before {
              left: -20px;
              border-right-color: #fff;
            }

            .chat-wrapper .chat-message.chat-message-recipient p {
              background-color: #fff;
              color: #1b2833;
              border-radius: 2px;
            }

            .chat-wrapper
              .chat-message.chat-message-sender
              .chat-message-wrapper,
            .chat-wrapper
              .chat-message.chat-message-sender
              .chat-message-content {
              float: right;
            }

            .chat-wrapper
              .chat-message.chat-message-sender-design_ac
              .chat-message-wrapper:before {
              right: -20px;
              border-left-color: #3e3e3f;
            }

            .chat-wrapper .chat-message.chat-message-sender-design_ac p {
              background: #3e3e3f;
              color: #fff;
              border-radius: 2px;
            }

            .chat-wrapper
              .chat-message.chat-message-sender-illust_ac
              .chat-message-wrapper:before {
              right: -20px;
              border-left-color: #dc4c65;
            }

            .chat-wrapper .chat-message.chat-message-sender-illust_ac p {
              background: #dc4c65;
              color: #fff;
              border-radius: 2px;
            }

            .chat-wrapper
              .chat-message.chat-message-sender-silhouette_ac
              .chat-message-wrapper:before {
              right: -20px;
              border-left-color: #41b9b8;
            }

            .chat-wrapper .chat-message.chat-message-sender-silhouette_ac p {
              background: #41b9b8;
              color: #fff;
              border-radius: 2px;
            }

            .chat-wrapper
              .chat-message.chat-message-sender-photo_ac
              .chat-message-wrapper:before {
              right: -20px;
              border-left-color: #509bdc;
            }

            .chat-wrapper .chat-message.chat-message-sender-photo_ac p {
              background: #509bdc;
              color: #fff;
              border-radius: 2px;
            }

            .chat-wrapper .chat-message.chat-message-sender img {
              float: right;
            }

            .chat-wrapper .chat-message .chat-message-content {
              display: table;
              overflow: hidden;
              border-radius: 2px;
            }

            .chat-wrapper .chat-message .chat-message-content:before {
              content: ' ';
              display: block;
            }

            .chat-wrapper .chat-message .chat-details {
              clear: both;
              width: 100%;
              display: table;
              overflow: hidden;
            }

            .chat-wrapper .chat-message .chat-details:before {
              content: ' ';
              display: block;
            }

            .chat-wrapper .chat-message .chat-details span {
              margin-right: 4px;
              color: #bbb;
            }

            @media (max-width: 992px) {
              .chat-wrapper {
                padding: 15px;
              }
            }

            .chat-wrapper .chat-message .chat-message-content:before {
              right: -20px;
              border-left-color: #ffd1a4;
            }

            .color-title-design_ac {
              color: #fff;
            }
          `}
        </style>
      </div>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  isAuthenticated: makeSelectIsAuthenticated(),
});
export default connect(mapStateToProps)(FAQComponent);
